import { useRuntimeConfig } from "#imports";
import * as Sentry from "@sentry/nuxt";

Sentry.init({
  enabled: useRuntimeConfig().public.sentry.environment !== "local",
  dsn: useRuntimeConfig().public.sentry.dsn,
  environment: useRuntimeConfig().public.sentry.environment,
  attachProps: true,
  // Vue: {
  //   config: {
  //     errorHandler: (error: any) => {
  //       Sentry.captureException(error);
  //     },
  //   },
  // },
});
